import React, { Component } from "react";
import "./Sidebar.scss";
import { withRouter } from "react-router-dom";
import { User } from "react-feather";
import { getUser } from "../../utils/localStorage";
import { DEPRENEUR_PROFILE_ENHANCEMENT_LINK } from "../../utils/constants";
import { MARKETING_TOOL_ENTRIES_LINK } from "../../utils/constants";

const userItem = {
	key: "LIST_USERS",
	path: "/home/users",
	name: "Users",
	PageTitle:"Manage Roles"
};
const facilitatorActionsViewContainer = {
	key: "FACILITATOR_ACTIONS_VIEW_CONTAINER",
	path: "/home/facilitator-actions-view-container/",
	name: "Facilitator Actions",
	PageTitle:"Service Follow Ups"
};

const ToolsTemplatesActionContainer={
	 
		key: "FACILITATOR_ACTIONS_VIEW_CONTAINER_NEW",
		path: "/home/facilitator-actions-view-container-new/",
		name:"Tools Templates Action",
		PageTitle:"Tools Templates Followups"

};

const threeSixtyDegreeViewContainer = {
	key: "THREE_SIXTY_DEGREE_VIEW_CONTAINER_NEW",
	path: "/home/three-sixty-degree-view-new/",
	name: "360 degree view",
	PageTitle:"360 Degree View"
};

const adminServiceRequestProgressionItem = {
	key: "ADMIN_SERVICE_PROGRESSION",
	path: "/home/admin-service-progression/",
	name: "SPM - All Services in Progression",
	PageTitle:"Facilitator Assignment Module"
};

const facilitatorServiceProgressionView = {
	key: "FACILITATOR_SERVICE_PROGRESSION",
	path: "/home/facilitator-service-progression/",
	name: "SPM - My Services in Progression",
	PageTitle:"Service Progression Module"
};

const adminExpertAppointmentContainer = {
	key: "ADMIN_EXPERT_APPOINTMENT",
	path: "/home/admin-expert-appointment/",
	name: "Expert Appointments",
	PageTitle:"Expert Appointments",
}

const adminExpertCalendarContainer = {
	key: "ADMIN_EXPERT_CALENDAR",
	path: "/home/admin-expert-calendar",
	name: "Expert Calendar",
	PageTitle: "Expert Calendar",
}

const myServiceRequestItem = {
	key: "MY_SERIVICE_REQUESTS",
	path: "/home/my-service-requests",
	name: "LPM - My Service Requests",
	PageTitle:"Lead Progression Module"
};

const adminServiceRequestItem = {
	key: "ADMIN_SERVICE_REQUESTS",
	path: "/home/admin-service-requests",
	name: "LPM - All Service Requests",
	PageTitle:"Handholder Assignment Module"
};

const reportItem = {
	key: "REPORTS",
	path: "/home/reports",
	name: "Download Reports",
	PageTitle:"Reports"
};

const paymentTrackerItem = {
	key: "PAYMENTTRACKER",
	path: "/home/payment-tracker",
	name: "Payment Tracker",
	PageTitle:"Payment Settlement Report"
};
const logoutItem = {
	key: "LOGOUT",
	path: "/home/logout",
	name: "Logout",
	PageTitle:""
};

const servicePackagingItem = {
	key: "SERVICE_PACKAGING",
	path: "/home/service-packaging/",
	name: "Offering Module",
	PageTitle:"Offering Module"
};

const spLedDashboard = {
	key: "SPLED_DASHBOARD",
	path: "/home/spled-dashboard",
	name: "SPLed Dashboard",
	PageTitle:"SPLed Dashboard"
};

const SPLedServiceRequests = {
	key: "SPLED_SERVICE_REQUESTS",
	path: "/home/spled-service-requests",
	name: "SPLed Service Requests",
	PageTitle:"SPLed Service Requests"
};


const EngagedUserDashboard={
	key: "ENGAGEDUSERS_CONTAINER",
	path: "/home/engagedusers-container",
	name:"Enagaged Users Dashboard",
	PageTitle:"Engaged Users Dashboard"

};

const NewAndEngagedUserDashboard={
	key: "NEWANDENGAGEDUSER_CONTAINER",
	path: "/home/newandengagedusers",
	name:"New and Enagaged Users Dashboard",
	PageTitle:"Performance Tracking of New and Engaged Users Dashboard"
}

const AssignedFacilitatorDashboard = {
	key: 'ASSIGNED_FACILITATORS',
	path: '/home/assignedfacilitators-container',
	name: 'Assigned Facilitator Dashboard',
	PageTitle: 'Assigned Facilitator Dashboard'
}


const DEPRENEUR_PROFILE_ENHANCEMENT = {
	key: "DEPRENEUR_PROFILE_ENHANCEMENT",
	path: DEPRENEUR_PROFILE_ENHANCEMENT_LINK,
	name: "dePreneur Profile Enhancement",
	PageTitle:"dePreneur Profile Enhancement"
};

const FACILITATOR_KRA_DASHBOARD = {
	key: "FACILITATOR_KRA_DASHBOARD",
	path: "/home/facilitator-kra-dashboard",
	name: "Facilitator KRA Dashboard",
	PageTitle:"Facilitator KRA Dashboard"
};

const MANAGERS_KRA_DASHBOARD = {
	key: "MANAGERS_KRA_DASHBOARD",
	path: "/home/managers-kra-dashboard",
	name: "Managers KRA Dashboard",
	PageTitle:"Managers KRA Dashboard"
};

const ADMIN_UPLOAD_REPORT = {
	key: "ADMIN_UPLOAD_REPORT",
	path: "/home/upload-kra-report",
	name: "Upload KRA Report",
	PageTitle:"Upload KRA Report"
};

const SEARCH_USER_BUSINESS_PROFILE = {
	key: "SEARCH_USER_BUSINESS_PROFILE",
	path: "/home/search-user-business-profile",
	name: "Search User Profile",
	PageTitle:"Search User Profile"
};

const USER_MARK_OUT_OF_OFFICE = {
	key: "USER_MARK_OUT_OF_OFFICE",
	path: "/home/mark-user-out-of-office",
	name: "Mark Out of Office",
	PageTitle:"Mark Out of Office"
};

const MARKETING_TOOL_ENTRIES = {
	key: "MARKETING_TOOL_ENTRIES",
	path: MARKETING_TOOL_ENTRIES_LINK,
	name: "Marketing Tool Entries",
	PageTitle:"Marketing Tool Entries"
};

const SP_TARGETS_CONFIGURATION = {
	key: "MARKETING_SP_TARGETS_CONFIGURATIONTOOL_ENTRIES",
	path: "/home/sp-target-configuration",
	name: "SP Targets Configuration",
	PageTitle:"Targets Configuration"
};

const DND_USERS_LIST = {
	key: "DND_USERS_LIST",
	path: "/home/dnd-users",
	name: "DND Users List",
	PageTitle:"DND Users List"
};

const TOOLS_TEMPLATES = {
	key: "TOOLS_TEMPLATES",
	path: "/home/admin-resource-requests",
	name: "Admin Tools Templates",
	PageTitle:"Resource Assignment"
};

const MY_TOOLS_TEMPLATES = {
	key: "MY_TOOLS_TEMPLATES",
	path: "/home/my-resource-assignment",
	name: "MY Tools Templates",
	PageTitle:"My Resource Assignment"
};

const serviceCatalogueContainer = {
	key: "SERVICE_CATALOGUE_VIEW",
	path: "/home/service-catalogue-view/",
	name: "Service Catalogue",
	PageTitle:"Service Catalogue"
};

const manageExternalServicePartnerContainer = {
	key: "MANAGE_EXTERNAL_PARTNER_VIEW",
	path: "/home/manage_external_partner_view/",
	name: "Manage External Partner",
	PageTitle:"Manage External Partner"
};

const resourceMasterContainer = {
	key: "RESOURCE_MASTER_VIEW",
	path: "/home/resource-master-view/",
	name: "Resource Master",
	PageTitle:"Resource Master"
};

const PartyInvoiceContainer = {
	key: "PARTYINVOICE_CONTAINER",
	path: "/home/partyinvoice",
	name:"Invoice Tracking",
	PageTitle:"Invoice Tracking"
}

const JpmcDashboard={
	key: "JPMCDASHBOARD_CONTAINER",
	path: "/home/jpmcdashboard",
	name:"JPMC Dashboard",
	PageTitle:"JPMC Dashboard"
}

const AnekDashboard={
	key: "ANEKDASHBOARD_CONTAINER",
	path: "/home/anekdashboard",
	name:"Anek Dashboard",
	PageTitle:"Anek Dashboard"
}

const JpmcExpenseDashboard={
	key: "JPMCEXPENSEDASHBOARD_CONTAINER",
	path: "/home/jpmcexpdashboard",
	name:"JPMC Expense Dashboard",
	PageTitle:"JPMC Expense Dashboard"
}

const ClosedServiceContainer = {
	key: "CLOSEDSERVICE_CONTAINER",
	path: "/home/closedservice",
	name:"Closed Services",
	PageTitle:"Closed Services"
}

const ProgramManagerMasterContainer = {
	key: "PROGRAM_MANAGER_MASTER",
	path: "/home/program-manager-master",
	name:"Program Manager Master",
	PageTitle:"Program Manager Master"
}

const PartnerMasterContainer = {
	key: "PARTNER_MASTER",
	path: "/home/partner-master",
	name:"Partner Master",
	PageTitle:"Partner Master"
}

const ProgramManagerPartnerAssociationContainer = {
	key: "PROGRAM_MANAGER_PARTNER_ASSOCIATION",
	path: "/home/programmanager-partner-association",
	name:"Program Manager Partner Association",
	PageTitle:"Program Manager Partner Association"
}

const IhclDashboard={
	key: "IHCLDASHBOARD_CONTAINER", 
	path: "/home/ihcldashboard",
	name:"IHCL Dashboard",
	PageTitle:"IHCL Dashboard"
}

const jpmcThreeSixtyDegreeViewContainer = {
	key: "JPMC_THREE_SIXTY_DEGREE_VIEW_CONTAINER",
	path: "/home/jpmc-three-sixty-degree-view/",
	name: "Jpmc 360 degree view",
	PageTitle:"Jpmc 360 Degree View"
};

const DreamBigNewAndEngagedUserDashboard={
	key: "DREAMBIGNEWANDENGAGEDUSER_CONTAINER",
	path: "/home/dreambignewandengagedusers",
	name:"dreamBIG New and Enagaged Users Dashboard",
	PageTitle:"Performance Tracking of dreamBIG New and Engaged Users Dashboard"
}

const JPMCTestimonials = {
	key: "JPMC_TESTIMONIALS",
	path: "/home/jpmc-testimonials/",
	name: "Beneficiary's Profile",
	PageTitle:"Beneficiary's Profile"
}

export const SELECTED_SIDE_BAR_ITEM_KEY = "SELECTED_SIDE_BAR_ITEM";

class SidebarContent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedItemPath: "",
			items: [],
		};
		this.unlisten = null;
	}
	componentDidMount() {
		const storageItem = localStorage.getItem(SELECTED_SIDE_BAR_ITEM_KEY);
		console.log("Window-1", window.location.pathname)
		const ihclDashboardPath = "/home/ihcldashboard";
		const user = getUser();
		console.log(user, ">>>>>user in SidebarContent.jsx");
		console.log(ihclDashboardPath, ">>>ihclDashboardPath")

		if (!user && !window.location.pathname == ihclDashboardPath) {
			this.props.history.push("/login");
			return;
		}

		if(user){
			const { email } = user;
			const { access_rights } = user;
			console.log("access rights==>", access_rights);
			if(user.role[0] === 12){
				if(window.location.pathname !== "/home/newandengagedusers"){
					this.props.history.push('/home/newandengagedusers')
				}
			}
			let items = [];

			const addItem = (item) => {
				if (!items.includes(item)) {
					items.push(item);
				}
			};

			if (access_rights["USER"]) {
				addItem(userItem);
			}
			if (access_rights["SERVICE REQUEST"]) {
				const serviceRequestRights = access_rights["SERVICE REQUEST"];
				if (serviceRequestRights.includes("ASSIGN")) {
					addItem(adminServiceRequestItem);
				}
				if (serviceRequestRights.includes("FETCH OWNED")) {
					addItem(myServiceRequestItem);
				}

				// if (true) {
				//   items.push(adminServiceRequestProgressionItem);
				// }
			}
			if (access_rights["REPORT"]) {
				addItem(reportItem);
			}
			if (
				access_rights["SERVICE"] &&
				access_rights["SERVICE"].includes("ASSIGN_FACILITATOR") &&
				access_rights["SERVICE"].includes("FETCH")
			)
				addItem(adminServiceRequestProgressionItem);
			if (access_rights["SERVICE"]) {
				const serviceRights = access_rights["SERVICE"];
				if (
					serviceRights.includes("FETCH OWNED") ||
					serviceRights.includes("DELIVER")
				) {
					addItem(facilitatorServiceProgressionView);
					addItem(facilitatorActionsViewContainer);
					addItem(ToolsTemplatesActionContainer);
				}
			}
			if (access_rights["REPORT"]&&access_rights["REPORT"].includes("PAYMENT_TRACKER_REPORT")) {
				addItem(paymentTrackerItem);
			}
			const hasDashboardRole = user.role[0] === 12
			const hasJpmcRole = user.role[0] === 13

			const threeSixtyRole = user?.role?.includes(20);
			
			if(threeSixtyRole){
				addItem(adminServiceRequestItem);
				addItem(adminServiceRequestProgressionItem);
				addItem(threeSixtyDegreeViewContainer);
			}

			if(!hasDashboardRole && !hasJpmcRole && !threeSixtyRole){
				addItem(threeSixtyDegreeViewContainer)
				addItem(PartyInvoiceContainer)
				addItem(ClosedServiceContainer)
			}
			
			const hasPackageManagerRole = user.role.includes(7);
			if (hasPackageManagerRole) 
			{
				addItem(servicePackagingItem);
			} 

			const hasSPReportRole = user.role.includes(9);
			if (hasSPReportRole) 
			{
				addItem(spLedDashboard);
				addItem(SPLedServiceRequests);
				addItem(EngagedUserDashboard);
				addItem(adminExpertAppointmentContainer)
				addItem(adminExpertCalendarContainer)
				addItem(AssignedFacilitatorDashboard)
				// items.push(serviceCatalogueContainer)
				// items.push(resourceMasterContainer)
				// items.push(manageExternalServicePartnerContainer)
			}
			if(user.role.includes(1)){
				addItem(serviceCatalogueContainer)
				addItem(resourceMasterContainer)
				addItem(manageExternalServicePartnerContainer)
			}

			
			if(user.role.includes(12)){
				addItem(NewAndEngagedUserDashboard)
			}

			if(user.role.includes(13)){
				addItem(JpmcDashboard)
				addItem(JpmcExpenseDashboard)
				addItem(jpmcThreeSixtyDegreeViewContainer)
				addItem(JPMCTestimonials);
				addItem(AnekDashboard);
			}

			if(user.role.includes(15)){
				addItem(ProgramManagerMasterContainer)
				addItem(PartnerMasterContainer)
				addItem(ProgramManagerPartnerAssociationContainer)
			}

			const hasSPTargetsRole = user.role.includes(1);
			if (hasSPTargetsRole||email==="aishwarya.kulkarni@deasra.co.in"||email==="nitish.kulkarni@deasra.co.in"||email==="prakash@deasra.co.in"||email==="nitish.kulkarni@deasra.co.in")
			{
				addItem(SP_TARGETS_CONFIGURATION);
				addItem(TOOLS_TEMPLATES);
				
			}

			const hasIHHRole = user.role.includes(4);
			if (hasIHHRole) 
			{
				addItem(DEPRENEUR_PROFILE_ENHANCEMENT);
			} 		

			const hasFacilitatorRole = user.role.includes(3)||user.role.includes(4);
			if (hasFacilitatorRole) 
			{
				addItem(FACILITATOR_KRA_DASHBOARD);
			}

			const hasFacilitatorKRARole = user.role.includes(10);
			if (hasFacilitatorKRARole) 
			{
				addItem(MANAGERS_KRA_DASHBOARD);
				addItem(ADMIN_UPLOAD_REPORT);
			} 

			const hasSearchUserProfileReportRole = user.role.includes(1);
			if (hasSearchUserProfileReportRole)
			{
				addItem(SEARCH_USER_BUSINESS_PROFILE);
			}

			if(!hasDashboardRole && !hasJpmcRole && !threeSixtyRole){
				addItem(USER_MARK_OUT_OF_OFFICE);
			}

			const hasAdminRole = user.role.includes(1);
			if (hasFacilitatorRole||hasAdminRole) 
			{
				addItem(MARKETING_TOOL_ENTRIES);
			} 

			const isFacilitatorRole = user.role.includes(4);
			if (isFacilitatorRole) 
			{
				addItem(DND_USERS_LIST);
			}

			const hasIhclDashboardRole = user.role.includes(16);
			if(hasIhclDashboardRole){
				addItem(IhclDashboard)
			}

			// const dreamBigDashboardRole = user.role.includes(16);
			const dreamBigDashboardRole = true;
			if(dreamBigDashboardRole && !threeSixtyRole){
				addItem(DreamBigNewAndEngagedUserDashboard)
			}
			// else if(dreamBigDashboardRole && threeSixtyRole){
			// 	items.push(DreamBigNewAndEngagedUserDashboard)
			// }

			const isFacilitatorRole1 = user.role.includes(3);
			if (isFacilitatorRole1) 
			{
				addItem(MY_TOOLS_TEMPLATES);
			}
			

			addItem(logoutItem);

			this.setState({
				selectedItemPath: storageItem || "",
				items,
			});
			// this.unlisten = this.props.history.listen((location, action) => {
			//   console.log("location change.");
			//   console.log(location.pathname);
			//   localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, location.pathname);
			//   this.setState({ selectedItemPath: location.pathname });
			// });
		} else if(ihclDashboardPath){
			let items = [];
			const addItem = (item) => {
				if (!items.includes(item)) {
					items.push(item);
				}
			};
			addItem(IhclDashboard)

			this.setState({
				selectedItemPath: storageItem || "",
				items,
			});
		}	
	}
	componentWillUnmount() {
		// if (this.unlisten) {
		//   this.unlisten();
		// }
	}
	handleItemClick = (item) => {
		this.setState({ selectedItemPath: item.path });
		localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, item.path);
		this.props.history.push(`${item.path}`);
		this.props.toggleSidebar();
		this.props.changePageTitle(item.PageTitle);
	};

	handleOutSideLink(item)
	{
		window.open(item.path, "_blank") //to open new page
	 }

	// handleLogout = () => {
	//   api.logout ().then(({data}) => {
	//     console.log(data)
	//     localStorage.clear();
	//     this.props.history.push('/login');
	//   })
	// }
	getDisplayName = () => {
		const user = getUser();
		const view = [];
		if (user) {
			if (user.first_name) {
				view.push(<div key={"name"}>{user.first_name}</div>);
			}
			if (user.email) {
				view.push(
					<div key={"email"}>
						<small>{user.email}</small>
					</div>
				);
			}
		}
		return view;
	};
	render() {
		const { selectedItemPath, items } = this.state;
		return (
			<div className="sidebar">
				<div className="sidebar-header">
					<User />
					<div className="display-name">{this.getDisplayName()}</div>
				</div>

				{items.map((item) => {
					if(item.key==="DEPRENEUR_PROFILE_ENHANCEMENT" ||item.key==="MARKETING_TOOL_ENTRIES")
					{
						return (
							<div
								className={`sidebar-item flex align-items-center row`}
								onClick={() => this.handleOutSideLink(item)}
								key={item.key}
							>
								<div className="ml-3 title">{item.name}</div>
							</div>
						);
					}
					else
					{
						return (
							<div
								className={`sidebar-item flex align-items-center row ${
									selectedItemPath === item.path ? "active" : ""
								}`}
								onClick={() => this.handleItemClick(item)}
								key={item.key}
							>
								{/* <div className="w20">
					<i className={item.icon} />
				  </div> */}
								<div className="ml-3 title">{item.name}</div>
							</div>
						);
					}
				})}
				{/* <div className="sidebar-item align-items-center row" onClick={this.handleLogout}>
          <div className="ml-3 title">Log out</div>
        </div> */}
				{/* <div className="sidebar-item help align-items-center row">
          <i className="fas fa-envelope" />
          <div className="ml10 title">Contact Us</div>
        </div>
        <div className="sidebar-item contact align-items-center row">
          <i className="fas fa-info-circle" />
          <div className="ml10 title">Help</div>
        </div> */}
			</div>
		);
	}
}
export default withRouter(SidebarContent);
